module.exports = {
  messages: {
    CN: {
      'brandList.brandName': '品牌名称',
      'brandList.stutus': '状态',
      'brandList.query': '查询',
      'brandList.enterPlease': '请输入品牌名称',
      'brandList.enterBrandNamePlease': '请输入品牌名称',
      'brandList.choosePlease': '请选择',
      'brandList.insertok': '新增成功',
      'brandList.brandPic': '品牌图片',
      'brandList.productNum': '商品数量',
      'brandList.firstLetter': '首字母',
      'brandList.updateTime': '更新时间',
      'brandList.operation': '操作',
      'brandList.all': '全部',
      'brandList.stopUsing': '停用',
      'brandList.startUsing': '启用',
      'brandList.edit': '编辑',
      'brandList.delete': '删除',
      'brandList.addBrand': '新建品牌',
      'brandList.editBrand': '编辑品牌',
      'brandList.brandComment': '品牌介绍',
      'brandList.total': '总条数',
      'brandList.add': '新建',
      'brandList.translate': '翻译',
      'brandList.cancel': '取消',
      'brandList.confirm': '确认',
      'brandList.deletedSuccessfully': '删除成功',
      'brandList.changeStatusSuccessfully': '更改状态成功',
      'brandList.simplifiedChinese': '简体',
      'brandList.upload': '上传',
      'brandList.uploadSuccessfully': '上传成功',
      'brandList.enterUploadBrandPic': '请上传品牌图片',
      'brandList.enterChooseBrandFirstLetter': '请选择品牌首字母',
      'productList.onTheShelf': '上架',
      'productList.offTheShelf': '下架'
    },
    JP: {
      'brandList.brandName': 'ブランド名',
      'brandList.stutus': '状態',
      'brandList.query': '検索',
      'brandList.enterPlease': 'ブランド名を入力してください',
      'brandList.enterBrandNamePlease': 'ブランド名を入力してください',
      'brandList.choosePlease': '選択してください',
      'brandList.insertok': '追加しました',
      'brandList.brandPic': '品牌图片',
      'brandList.productNum': '商品数量',
      'brandList.firstLetter': '頭文字',
      'brandList.updateTime': '更新時間',
      'brandList.operation': '操作',
      'brandList.all': '全部',
      'brandList.stopUsing': '無効',
      'brandList.startUsing': '有効',
      'brandList.edit': '編集',
      'brandList.delete': '削除',
      'brandList.addBrand': 'ブランドを追加',
      'brandList.editBrand': 'ブランドを編集',
      'brandList.brandComment': 'ブランド紹介',
      'brandList.total': '総数',
      'brandList.add': '新規作成',
      'brandList.translate': '翻訳',
      'brandList.cancel': 'キャンセル',
      'brandList.confirm': '確定',
      'brandList.deletedSuccessfully': '削除しました',
      'brandList.changeStatusSuccessfully': '更改状态成功',
      'brandList.simplifiedChinese': '简体',
      'brandList.upload': 'アップロード',
      'brandList.uploadSuccessfully': '上传成功',
      'brandList.enterUploadBrandPic': '请上传品牌图片',
      'brandList.enterChooseBrandFirstLetter': 'ブランドの頭文字を選択してください',
      'productList.onTheShelf': '販売開始',
      'productList.offTheShelf': '販売停止'
    }
  }
};